/**
 * @platform Android, iOS
 * @since 7.1.0
 */
export enum EventStatus {
  /**
   * @platform iOS
   * @since 7.1.0
   */
  NONE = 'none',
  /**
   * @platform Android, iOS
   * @since 7.1.0
   */
  CONFIRMED = 'confirmed',
  /**
   * @platform Android, iOS
   * @since 7.1.0
   */
  TENTATIVE = 'tentative',
  /**
   * @platform Android, iOS
   * @since 7.1.0
   */
  CANCELED = 'canceled',
}
